export default __webpack_public_path__ + "static/media/SIFA_EPILOGFIN2.749a2c37.mp3";